import React, { useEffect, useMemo, useState } from 'react'
import Fuse, { IFuseOptions } from 'fuse.js'
import { SearchBar } from './SearchBar'

interface FuseSearchBarProps<T> {
  rawList: T[]
  onSearchResult: (items: T[]) => void
  options: IFuseOptions<T>
}

export const FuseSearchBar = <T,>(props: FuseSearchBarProps<T>) => {
  const { rawList, onSearchResult, options } = props

  const [searchQuery, setSearchQuery] = useState('')

  const fuse = useMemo(() => new Fuse(rawList, options), [rawList, options])

  useEffect(() => {
    const searchResult =
      searchQuery.trim().length > 0 ? fuse.search(searchQuery).map(({ item }) => item) : rawList
    onSearchResult(searchResult)
  }, [fuse, onSearchResult, rawList, searchQuery])

  return <SearchBar value={searchQuery} onChangeText={setSearchQuery} />
}
